import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import ResponsiveImage from './ResponsiveImage';

export default function FeatureSection() {
  const { t } = useTranslation();

  const features = [
    { id: 1, key: 'fast', imgBase: '/images/feature-1' },
    { id: 2, key: 'friendly', imgBase: '/images/feature-2' },
    { id: 3, key: 'motivated', imgBase: '/images/feature-3' },
  ];

  return (
    <section className="bg-white py-24 px-4 lg:px-8 space-y-32">
      {features.map((f, idx) => {
        const fromLeft = idx % 2 === 0;
        const xOffset = fromLeft ? -150 : 150;
        return (
          <motion.div
            key={f.id}
            initial={{ opacity: 0, x: xOffset }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7, ease: 'easeOut' }}
            viewport={{ once: true, amount: 0.3 }}
            className={`max-w-7xl mx-auto w-full flex flex-col md:flex-row items-center justify-between gap-12 ${
              fromLeft ? '' : 'md:flex-row-reverse'
            }`}
          >
            <ResponsiveImage
              srcBase={f.imgBase}
              alt={t(`features.${f.key}.title`)}
              className="w-full max-w-md md:max-w-xl rounded-3xl shadow-xl"
              loading="lazy"
            />
            <div className="max-w-xl text-center md:text-left space-y-6">
              <h3 className="text-3xl md:text-5xl font-bold text-brand">
                {t(`features.${f.key}.title`)}
              </h3>
              <p className="text-lg md:text-xl text-gray-700 leading-relaxed">
                {t(`features.${f.key}.desc`)}
              </p>
            </div>
          </motion.div>
        );
      })}
    </section>
  );
}
